// newspage-backend answers a free member's News Alert response with this code once the
// profile has a counted piece of coverage (profiles/free-coverage.ts).
export const FREE_COVERAGE_REACHED = 'FREE_COVERAGE_REACHED';

export const freeCoverageMessage = ({ count, latestCoverage }) => {
    const lead =
        count === 1 && latestCoverage?.publisher
            ? `You've been quoted in ${latestCoverage.publisher} through Newspage.`
            : `You've had ${count} pieces of coverage through Newspage.`;
    return `${lead} Free accounts can respond until their first piece, so to send this response you'll need Plus or Pro.`;
};

// The block comes either ahead of time on the company's plan or from the rejected submit.
export const getFreeCoverage = (plan, error) => {
    if (error?.code === FREE_COVERAGE_REACHED) return error.details ?? null;
    if (plan?.type === 'free' && plan.freeCoverage?.count > 0) {
        return plan.freeCoverage;
    }
    return null;
};
